import React from "react";

import "./skeleton-listing-card.css";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonListingCard = ({ isDestinationListing = false }) => {
  return (
    <div className="card-skeleton-loader">
      <div className="skeleton-card-left">
        <Skeleton height={"100%"} />
      </div>

      <div className="skeleton-card-right">
        <div className="skeleton-card-right-top">
          <Skeleton width={"100%"} className="skeleton-card-heading" />
          <Skeleton width={"80%"} className="skeleton-card-address" />
        </div>
        <div className="skeleton-card-right-bottom">
          <div
            className="skeleton-card-room-info"
            data-isdestination={isDestinationListing}
          >
            <Skeleton height={15} width={"100%"} />
            <Skeleton height={15} width={"100%"} />
            <Skeleton height={15} width={"100%"} />
            <Skeleton height={15} width={"100%"} />
            <Skeleton height={15} width={"100%"} />
          </div>

          {!isDestinationListing && (
            <div className="skeleton-card-price-info">
              <Skeleton className="skeleton-card-price" />
              <Skeleton className="skeleton-card-price" />
              <Skeleton className="skeleton-card-price" />
              <Skeleton className="skeleton-card-btn" />
            </div>
          )}

          {!isDestinationListing && (
            <div className="skeleton-card-price-info-sm">
              <Skeleton height={30} width={75} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SkeletonListingCard;
